module.exports = __webpack_public_path__ + "static/img/图层54.06e0672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层54.png
// module id = Jy8n
// module chunks = 0